import React, {
    useState,
    useEffect,
    useCallback,
    useRef,
    memo
} from 'react';
import {
    Grid,
    IconButton,
    SwipeableDrawer,
    makeStyles,
    CircularProgress,
    Typography
} from '@material-ui/core';
import Firebase from 'firebase/app';
import 'firebase/firestore';
import FilterIcon from '@material-ui/icons/FilterList';
import {Virtuoso} from 'react-virtuoso'
import {FeedListItem} from "./FeedListItem";
import FilterHeader from "./FilterHeader";
import FacebookIcon from '@material-ui/icons/Facebook';
import TwitterIcon from '@material-ui/icons/Twitter';
import InstagramIcon from '@material-ui/icons/Instagram';
import YouTubeIcon from '@material-ui/icons/YouTube';
import LinkedInIcon from '@material-ui/icons/LinkedIn';
import AllInclusiveIcon from '@material-ui/icons/AllInclusive';
import AnnouncementIcon from '@material-ui/icons/Announcement';


const NetworkID = {
    1:'Twitter',
    2:'Instagram',
    3:'Facebook',
    4:'Pinterest',
    5:'Google',
    6:'Vine',
    7:'Flickr',
    8:'Youtube',
    9:'Tumblr',
    10:'RSS',
    11:'LinkedIn',
};

const networks: any = {
    selected: 0,
    0: {
        title: 'All',
        icon: <AllInclusiveIcon  />,
        plainIcon: <AllInclusiveIcon />,
        iconColor: '#A3D032',
        activated: true,
        selected: true
    },
    1:{
        title: 'Twitter',
        icon: <TwitterIcon />,
        plainIcon: <TwitterIcon  />,
        iconColor: '#1da1f2',
        userScheme: 'twitter://user?screen_name=',
        postScheme: 'twitter://status?id=',
        activated: true,
        selected: false,
    },
    2:{
        title: 'Instagram',
        icon: <InstagramIcon />,
        plainIcon: <InstagramIcon  />,
        iconColor: '#c32aa3',
        userScheme: 'instagram://user?username=',
        postScheme: 'instagram://media?id=',
        activated: true,
        selected: false,
    },
    3:{
        title: 'Facebook',
        icon: <FacebookIcon />,
        plainIcon: <FacebookIcon  />,
        iconColor: '#1877f2',
        userScheme: 'fb://page/?id=',
        postScheme: 'https://www.facebook.com/ManhattanCollegeEdu/posts/',
        activated: false,
        selected: false,
    },
    8:{
        title: 'YouTube',
        icon: <YouTubeIcon />,
        plainIcon: <YouTubeIcon  />,
        iconColor: '#ff0000',
        userScheme: 'youtube://www.youtube.com/user/',
        postScheme: 'youtube://www.youtube.com/watch?v=',
        activated: true,
        selected: false,
    },
    10:{
        title: 'RSS',
        icon: <AnnouncementIcon />,
        plainIcon: <AnnouncementIcon  />,
        iconColor: '#D45D00',
        activated: true,
        selected: false,
    },
    11:{
        title: 'LinkedIn',
        icon: <LinkedInIcon />,
        plainIcon: <LinkedInIcon  />,
        iconColor: '#007bb5',
        userScheme: 'linkedin://school/manhattan-college/',
        postScheme: 'linkedin://posts/',
        activated: false,
        selected: false,
    },
};


export const FeedMaterial = (props:any) => {

    const [filterOpen, setFilterOpen] = useState(false);
    const total = useRef(0);
    const feed = useRef();
    const prevSelected = useRef(0);
    const [posts, setPosts] = useState<any[]>([]);
    const loading = useRef(false);
    const classes = useStyles();
    const sources = useRef();
    const [filteredNetworks, filterNetworks] = useState(networks);
    const [selectedNetwork, selectNetwork] = useState<number>(0);
    const controller: AbortController = new AbortController();
    const signal = controller.signal;

    useEffect(() => {
        loadMore()

    }, []);

    useEffect(()=> {
            loadMore()
        return () => controller.abort()
        },
        [ filteredNetworks])



    const loadMore = useCallback(async (index: number = 0) => {

        if (loading.current && posts.length >= total.current) {
            return
        }
        let postURL = `https://jaspercardws2.manhattan.edu/curator_proxy/feeds/1ee1b25a-0341-4874-9a1b-b4ba1726bb52/posts?limit=25&offset=${index}`
        if (filteredNetworks.selected != 0) {
          postURL = `${postURL}&network_id=${filteredNetworks.selected}`

        }
        let urls = [
            fetch(postURL, {signal}),
        ];
        if (!sources.current) {
            urls.push(
                fetch('https://jaspercardws2.manhattan.edu/curator_proxy/sources?feed_id=ee155952-eee5-4c57-9dbb-ec8d439366d7', {signal})
            )
        }

        loading.current = true;
        try {
            const responses = await Promise.all(urls);

            const postResponse = responses[0];
            if (responses.length > 1) {
                const sourcesResponse = responses[1];

                if (sourcesResponse.ok) {
                    const sourcesData = await sourcesResponse.json();
                    let temp: any = {};

                    sourcesData.forEach((source: any) => {
                        temp[source.id] = {
                            name: source.name,
                            activated: false,
                        }
                    });
                    sources.current = temp
                }
            }

            if (postResponse.ok) {
                const data = await postResponse.json();

                total.current = data.postCount
                if (data.posts.length > 0) {
                    loading.current = false;
                    let tempPosts: any[];

                    if (prevSelected.current != filteredNetworks.selected) {
                        tempPosts = [];
                        prevSelected.current = filteredNetworks.selected;

                    } else {
                        tempPosts = posts
                    }
                    setPosts([...tempPosts, ...data.posts]);


                }

            }

            loading.current = false;

        } catch (error) {
            // console.log(error);
            loading.current = false;
        }
    }, [posts, filteredNetworks]);

    const getItems = (index: any) => {
        if (posts[index]) {
            const post: any = posts[index];

            return (

                <div className={classes.container}>
                    <FeedListItem
                        post={post}
                        source={sources.current[post.source_id]}
                    />
                </div>
            )
        } else {
             return (<></>)
        }
    };

    const filterPostItems = (posts: any[]) => {
        let id: number;
        let network: any;

       return posts.filter((post: any) => {
            id = post.network_id;
            network = filteredNetworks[id];
            return network.selected;
        })
    };
    return (
        <>
        <Grid
            container
            className={classes.root}
        >
            <Grid
                item
                xs={12}
                className={classes.filterBar}
            >
                <Grid
                    container
                    justify={'space-between'}
                >
                    <Grid
                        xs={12}
                        item
                    >
                    <FilterHeader
                        networks={filteredNetworks}
                        onSelect={(network: any) => {
                            setPosts([]);

                            filterNetworks({...filteredNetworks, ...network})
                            }
                        }/>
                    </Grid>
                    {/*<Grid*/}
                    {/*    xs={2}*/}
                    {/*    item*/}
                    {/*>*/}
                    {/*    <IconButton*/}
                    {/*        onClick={() => {*/}
                    {/*            setFilterOpen(true)*/}
                    {/*        }}*/}
                    {/*    >*/}
                    {/*        <FilterIcon/>*/}
                    {/*    </IconButton>*/}

                    {/*</Grid>*/}
                </Grid>

            </Grid>
            <Grid
                item
                xs={12}
                className={classes.scrollContainer}
            >
                <Virtuoso
                    overscan={500}
                    style={{ height: '100%', width: 'auto', marginLeft: 16, marginRight: 16 }}
                    totalCount={posts.length}
                    item={getItems}
                    endReached={loadMore}
                    maxRangeSize={1000}

                    footer={() => {

                   return posts.length <= total.current ? <>{ <CircularProgress className={classes.loading}/> } </>:
                        <Typography style={{ padding: '2rem', textAlign: 'center', paddingBottom: '7rem' }}>
                             No More Post
                    </Typography>}}

                    />
            </Grid>
        </Grid>
        <SwipeableDrawer
    anchor={'right'}
    onClose={() => setFilterOpen(false)}
    onOpen={() => {}}
    open={filterOpen}>
        </SwipeableDrawer>
        </>
    )
};

const useStyles = makeStyles({
    root:{
        width: '100%',
        height: '100%',
    },
    filterBar: {
        height: 60,
        paddingTop: 4,
        backgroundColor: '#F1F1EE',
        paddingLeft: 16,
        paddingRight: 16,

    },
    container: {
        paddingTop: 16,
        paddingBottom: 16,
    },
    loading: {
        position: 'relative',
        left: '50%',
        transform: 'translate(-50%, 0)'
    },
    scrollContainer: {
        height: 'calc(100% - 60px)'
    }

});